import { render, staticRenderFns } from "./wxchronicscheme.vue?vue&type=template&id=374b63a1&scoped=true&"
import script from "./wxchronicscheme.vue?vue&type=script&lang=js&"
export * from "./wxchronicscheme.vue?vue&type=script&lang=js&"
import style0 from "./wxchronicscheme.vue?vue&type=style&index=0&id=374b63a1&lang=scss&scoped=true&"
import style1 from "./wxchronicscheme.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374b63a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('374b63a1')) {
      api.createRecord('374b63a1', component.options)
    } else {
      api.reload('374b63a1', component.options)
    }
    module.hot.accept("./wxchronicscheme.vue?vue&type=template&id=374b63a1&scoped=true&", function () {
      api.rerender('374b63a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wxreport/components/wxchronicscheme.vue"
export default component.exports